import { createRequiredContext } from '../createRequiredContext';
const { useContext, Provider, Context, Consumer } = createRequiredContext('AddressFormatter');
export const AddressFormatterProvider = Provider;
export const AddressFormatterConsumer = Consumer;
export const AddressFormatterContext = Context;
export const useAddressFormatter = useContext;
//# sourceMappingURL=AddressFormatterProvider.js.map